import React from 'react';
import { Doughnut } from 'react-chartjs-2';


const DonutChart = (props) => {
    const data = {
        labels: props.labels,
        datasets: props.datasets
    };
    
    return (
        <div className={`${props.className}`}>
            <Doughnut data={data} width={props.width} height={props.height} legend={{ position: "bottom" }} />
        </div>
    );
};

export { DonutChart };